import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Label from 'app/commonComponents/atoms/label';
import Field from 'app/commonComponents/atoms/input';

const WaitingListCheckbox = ({
  checkboxName,
  checkboxClass,
  checkboxLabelClass,
  checkboxInputClass,
  checkboxLabel,
  checkboxLabelId,
  checkboxOnChange,
  checked,
  error,
  ...props
}) => (
  <Label htmlFor={checkboxName} className={checkboxClass || ''}>
    <span className="form-checkbox">
      <Field
        type="checkbox"
        name={checkboxName}
        id={checkboxName}
        className={`form-checkbox__input ${checkboxInputClass || ''}`}
        checked={checked}
        onChange={checkboxOnChange}
        {...props}
      />
      <span className={`form-checkbox__checkbox ${error ? 'form-checkbox__highlight-error' : ''}`} />
    </span>
    <span className={`form-checkbox__label ${checkboxLabelClass || ''}`}>
      {checkboxLabel || <FormattedMessage id={checkboxLabelId} />}
    </span>
  </Label>
);

WaitingListCheckbox.defaultProps = {
  checkboxClass: '',
  checkboxLabelClass: '',
  checkboxLabelId: '',
  checkboxLabel: '',
  checkboxInputClass: '',
  checked: false,
};

WaitingListCheckbox.propTypes = {
  checkboxName: PropTypes.string.isRequired,
  checkboxClass: PropTypes.string,
  checkboxLabelClass: PropTypes.string,
  checkboxLabelId: PropTypes.string,
  checkboxLabel: PropTypes.string,
  checkboxInputClass: PropTypes.string,
  checkboxOnChange: PropTypes.func.isRequired,
  checked: PropTypes.bool,
};

export default WaitingListCheckbox;
